<template>
  <div>
    <label
      class="checkbox"
      v-for="position of positions" :key="position.code"
    >
      <input
        type="checkbox"
        v-model="selected"
        :value="position"
      />
      {{ position.name }}
    </label>
  </div>
</template>

<script lang="ts">
import { Position } from '@/store/master/types';
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class InputPosition extends Vue {
  @Prop() value!: Position[]

  created() {
    this.$store.dispatch('fetchMasterPositions')
  }

  get positions(): Position[] {
    return this.$store.state.master.positions
  }

  get selected(): Position[] {
    return this.value
  }

  set selected(positions: Position[]) {
    this.$emit('input', positions)
  }
}
</script>

<style scoped>
input[type="checkbox"] {
  margin-right:8px;
}
.checkbox {
  margin-right:20px;
}
</style>
